"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _index = _interopRequireDefault(require("../common/dropdown/index"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var MenuButton = /*#__PURE__*/(0, _reactEmotion.default)('button', {
  target: "e1psni9n0"
})("height:34px;width:34px;min-width:0px;background:transparent !important;padding:0;span{display:flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:50%;color:#424A50;background:", function (props) {
  return props.active ? '#ededed' : '';
}, "}&:hover,&:focus{background:transparent;span{background:#ededed;}}");

var ButtonDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonDropdown, _React$Component);

  var _super = _createSuper(ButtonDropdown);

  function ButtonDropdown(props) {
    var _this;

    _classCallCheck(this, ButtonDropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var onClick = _this.props.button.onClick;

      _this.toggle(true);

      if (onClick && typeof onClick === 'function') {
        onClick(e);
      }
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(ButtonDropdown, [{
    key: "toggle",
    value: function toggle(open) {
      this.setState({
        open: open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_reactTether.default, {
        attachment: "top ".concat(this.props.dropdown.anchor || 'right'),
        targetAttachment: "bottom ".concat(this.props.dropdown.anchor || 'right'),
        constraints: [{
          to: 'window',
          attachment: 'together',
          pin: true
        }]
      }, this.props.button.menu ? /*#__PURE__*/_react.default.createElement(MenuButton, {
        className: 'cs-button ' + this.props.button.className,
        active: this.state.open,
        onClick: this.onClick,
        "data-test-id": this.props.button.testID,
        disabled: this.props.button.disabled,
        style: this.props.button.style
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons"
      }, this.props.button.text)) : /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": this.props.button.testID,
        className: 'cs-button ' + this.props.button.className,
        disabled: this.props.button.disabled,
        style: this.props.button.style,
        onClick: this.onClick
      }, this.props.button.text), this.state.open && /*#__PURE__*/_react.default.createElement(_index.default, _extends({
        open: true
      }, this.props.dropdown, {
        theme: this.props.theme,
        clickCloses: this.props.dropdown.clickCloses,
        onClose: function onClose() {
          _this2.props.onDropdownClose();

          _this2.toggle(false);
        }
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ButtonDropdown;
}(_react.default.Component);

ButtonDropdown.defaultProps = {
  onDropdownClose: function onDropdownClose() {},
  theme: 'light'
};
ButtonDropdown.propTypes = {
  button: _propTypes.default.shape({
    className: _propTypes.default.string,
    text: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
    disabled: _propTypes.default.bool,
    onClick: _propTypes.default.func,
    testID: _propTypes.default.string,
    style: _propTypes.default.object,
    menu: _propTypes.default.bool
  }).isRequired,
  dropdown: _propTypes.default.shape({
    content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string, _propTypes.default.array]).isRequired,
    anchor: _propTypes.default.oneOf(['right', 'left']),
    clickCloses: _propTypes.default.bool,
    onClose: _propTypes.default.func
  }).isRequired,
  onDropdownClose: _propTypes.default.func,
  theme: _propTypes.default.string
};
var _default = ButtonDropdown;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MenuButton, "MenuButton", "/Users/darcy/sites/cs-theme/src/components/buttondropdown/index.js");
  reactHotLoader.register(ButtonDropdown, "ButtonDropdown", "/Users/darcy/sites/cs-theme/src/components/buttondropdown/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/buttondropdown/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();